import { Flex } from '@sequencehq/core-components'
import { RevRecHeader } from 'RevenueRecognition/view/common/RevRecHeader'
import { RevenueWaterfallExportToCsv } from './RevenueWaterfallExportToCsv'
import type { RevenueWaterfallQueryParams } from './RevenueWaterfallTable/types'

type Props = {
  filters: RevenueWaterfallQueryParams
}

export const RevenueWaterfallHeader = ({ filters }: Props) => {
  return (
    <RevRecHeader>
      <RevRecHeader.Breadcrumbs route="revenue-waterfall" />
      <Flex paddingTop="8px">
        <RevenueWaterfallExportToCsv filters={filters} />
      </Flex>
    </RevRecHeader>
  )
}
